var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandidates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.165V19.165C3 18.1041 3.42143 17.0867 4.17157 16.3366C4.92172 15.5864 5.93913 15.165 7 15.165H11C12.0609 15.165 13.0783 15.5864 13.8284 16.3366C14.5786 17.0867 15 18.1041 15 19.165V21.165M16 3.29498C16.8604 3.51528 17.623 4.01568 18.1676 4.71729C18.7122 5.4189 19.0078 6.28181 19.0078 7.16998C19.0078 8.05815 18.7122 8.92106 18.1676 9.62267C17.623 10.3243 16.8604 10.8247 16 11.045M21 21.165V19.165C20.9949 18.2822 20.6979 17.4258 20.1553 16.7294C19.6126 16.033 18.8548 15.5357 18 15.315M5 7.16498C5 8.22584 5.42143 9.24326 6.17157 9.99341C6.92172 10.7436 7.93913 11.165 9 11.165C10.0609 11.165 11.0783 10.7436 11.8284 9.99341C12.5786 9.24326 13 8.22584 13 7.16498C13 6.10411 12.5786 5.0867 11.8284 4.33655C11.0783 3.58641 10.0609 3.16498 9 3.16498C7.93913 3.16498 6.92172 3.58641 6.17157 4.33655C5.42143 5.0867 5 6.10411 5 7.16498Z",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidates);
export default __webpack_public_path__ + "static/media/candidates.ad851f216409175271983bb92d2d9a0c.svg";
export { ForwardRef as ReactComponent };